export const isValidUrl = (urlString: string): boolean =>
  isHttpUrl(urlString);

export const addProtocolIfMissing = (value: string): string =>
  value?.trim()
    ? /^[a-z][a-z\d+.-]*:/i.test(value)
      ? value.trim()
      : `https://${value.trim()}`
    : "";

export const isHttpUrl = (value: string): boolean => {
  if (!value) return false;
  try {
    const url = new URL(addProtocolIfMissing(value));
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const normalizeHttpUrl = (value: string): string | undefined => {
  const normalized = addProtocolIfMissing(value);
  return isHttpUrl(normalized) ? normalized : undefined;
};

